import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import iconMap from "../../../../../assets/icons/Icons";
import {
  OverallBg,
  ThemeBasedColorHeader,
  ThemeBasedColorMenubar,
} from "src/shared/modules/profile/theme/themeCheacker";
import usePermission from "src/business-types/grocery/hooks/usePermission";
import { reactAppVersion } from "src/features/auth/axiosConfig";

function SettingMenu() {
  const location = useLocation();
  const [isMobileDropdown, setIsMobileDropdown] = useState(false);
  const { hasPermission } = usePermission()


  useEffect(() => {
    const checkMobile = () => setIsMobileDropdown(window.innerWidth < 900);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const basePath = `/grocery/${reactAppVersion}/admin`;

  /* ✅ Add permission for each menu */
  const menuItems = [
    {
      icon: iconMap["category"],
      path: `${basePath}/categories`,
      name: "Categories",
      permission: "category_view",
    },
    {
      icon: iconMap["product"],
      path: `${basePath}/products`,
      name: "Products",
      permission: "product_view",
    },
    {
      icon: iconMap["customer"],
      path: `${basePath}/customers`,
      name: "Customers",
      permission: "customer_view",
    },
    {
      icon: iconMap["uom"],
      path: `${basePath}/UOM`,
      name: "Unit of Measurement",
      permission: "product_view",
    },
    {
      icon: iconMap["employee"],
      path: `${basePath}/employees`,
      name: "Employees",
      permission: "user_view",
    },
    // {
    //   icon: iconMap["configration"],
    //   path: `${basePath}/configurations`,
    //   name: "Configurations",
    //   permission: "setting_view",
    // },
  ];

  /* ✅ Filter menu based on permission */
  const filteredMenu = menuItems.filter((item) =>
    hasPermission(item.permission)
  );

  return (
    <div className="w-fill p-1">
      <div
        className={`flex flex-wrap md:flex-nowrap overflow-hidden ml-1 mr-4 mt-2 pl-1 py-1 rounded-lg ${ThemeBasedColorMenubar()} shadow-inner shadow-indigo-500/50 items-center setting-menu`}
      >
        {filteredMenu.map(({ icon: IconComponent, path, name }) => {
          const isActive = location.pathname === path;

          return (
            <Link
              to={path}
              key={path}
              className={`flex gap-2 items-center font-bold py-1 px-5 h-10 m-1 transition duration-300 transform whitespace-nowrap ${isActive
                ? `scale-100 text-black mt-2 -mb-3 rounded-t-lg shadow-md shadow-gray-500 ${OverallBg()}`
                : `hover:text-white hover:scale-95 border ${ThemeBasedColorHeader()} rounded-lg shadow shadow-gray-400`
                }`}
            >
              <IconComponent />
              <span
                className={`text-sm truncate ${isMobileDropdown ? "hidden" : ""
                  }`}
                title={name}
              >
                {name}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default SettingMenu;